import React from 'react'
import DayCalendar from './day-calendar/dayCalendar'
import WeekCalendar from './week-calendar/weekCalendar'
import MonthCalendar from './month-calendar/monthCalendar'

export default class CalendarPreview extends React.Component {

  render() {
    {
      const { calendarType ,numEvents, events, upcomingEventsList} = this.props;
      return <> {
        calendarType == 0 ? <MonthCalendar {...this.props} upcomingEventsList={upcomingEventsList} />
          : calendarType == 1 ? <WeekCalendar  {...this.props} upcomingEventsListweek={upcomingEventsList}  />
            : <DayCalendar   {...this.props} upcomingEventsListday={upcomingEventsList}  />
      }
      </>

    }
  }
}